export class GetTableDataQualityPartitionsResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "partitionFields",
            "baseName": "partitionFields",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "partitions",
            "baseName": "partitions",
            "type": "Array<TableDataQualityPartitionRow>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return GetTableDataQualityPartitionsResponse.attributeTypeMap;
    }
    constructor() {
    }
}
